<div class='tile-container' *ngIf='size' [style.width.px]='size.width' [style.height.px]='size.height'>
    <div class="tile d-flex flex-column">
        <div *ngIf='title' class="vizTitle">{{title}}</div>
        <div class="tile-content">
            <ng-content></ng-content>
        </div>
    </div>